const userReducer = (state, action) => {
  switch (action.type) {
    case 'SET_USER': {
      return action.payload;
    }
    case 'CLEAR_USER': {
      return false;
    }
    default:
      return state;
  }
};

const patronReducer = (state, action) => {
  switch (action.type) {
    case 'SET_PATRON': {
      localStorage.setItem('rfs:patron', action.payload);
      return action.payload;
    }
    case 'CLEAR_PATRON': {
      localStorage.removeItem('rfs:patron');
      return false;
    }
    default:
      return state;
  }
};

export default function authReducer(state, action) {
  const { user, patron } = state;

  return {
    user: userReducer(user, action),
    patron: patronReducer(patron, action),
  };
}
